
export class PendingOrderType {

  constructor(
    public code?: string,
    public translate?: string
  ) { }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/pending-order-type.ts